<template>
  <a-dialog ref="dialog" name="refresh_keywords" :loading="loading" size="small" @open="opened" @close="$reset">
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content">
      {{ $t('refresh-positions', { ids: this.ids.length}) }}
      <v-alert class="mt-4 mb-0" type="info" text border="left" icon="mdi-lightbulb-on-outline">
        {{ $t('compare') }}
      </v-alert>
    </div>
    <span slot="actions">
      <v-btn color="warning" text @click="submit"> {{ $tc('refresh-positions-submit', ids.length ) }}</v-btn>
    </span>
  </a-dialog>
</template>

<script>
import moment from 'moment'

export default {
  name: 'RefreshKeywordsDialog',
  data () {
    return {
      loading: '',
      ids: []
    }
  },
  methods: {
    opened ({ ids }) {
      if (ids.length > 0) {
        this.ids = ids
      } else {
        this.ids = this.$services.monitoring.monitors.all.map(monitor => monitor.id)
      }
    },
    async submit () {
      this.loading = this.$t('planning')

      try {
        const response = (await this.$api.post('monitors/refresh', { ids: this.ids })).data
        this.$ui.success(this.$t('success'))
        this.$bus.emit('monitoring/require_refresh')
        this.$bus.emit('monitoring/change_date', {
          current: moment(response.date).format('YYYY-MM-DD HH:mm'),
          comparison: moment(response.date).format('HH:mm') === '00:00' ? moment(response.date).subtract(1, 'day').format('YYYY-MM-DD 00:00') : moment(response.date).format('YYYY-MM-DD 00:00')
        })
        if (this.$refs.dialog) this.$refs.dialog.close()
      } catch (err) {
        if (err.exception === 'ThrottledRefreshMonitorException') {
          if (this.$account.getSubscription('check-position').name === 'default') {
            this.$bus.emit('notification/payment_required_for_more_monitor_refresh')
          } else {
            this.$bus.emit('notification/account_limitation_for_more_monitor_refresh')
          }
        }
      } finally {
        this.loading = ''
      }
    }
  }
}
</script>

<i18n>
{
	"en": {
		"compare": "The new positions will be compared to the first positions of the day.",
		"planning": "Planning the refresh",
		"refresh-positions": "Would you like to refresh the positioning of {ids} keyword(s)? This operation may take several minutes.",
		"refresh-positions-submit": "Refresh {n} keyword | Refresh {n} keywords",
		"success": "The update of the positions has been programmed successfully.",
		"title": "Refresh positions"
	},
	"es": {
		"compare": "Las nuevas posiciones se compararán con las primeras posiciones del día.",
		"planning": "Planificación de la actualización",
		"refresh-positions": "¿Desea actualizar el posicionamiento de {ids} palabra(s) clave? Esta operación puede tardar varios minutos.",
		"refresh-positions-submit": "Actualizar {n} palabra clave | Actualizar {n} palabras clave",
		"success": "La actualización de las posiciones se ha programado con éxito.",
		"title": "Actualizar posiciones"
	},
	"fr": {
		"compare": "Les nouvelles positions seront comparées aux premières positions du jour.",
		"planning": "Planification de l'actualisation",
		"refresh-positions": "Souhaitez-vous rafraîchir le positionnement de {ids} mot(s) clé(s) ? Cette opération peut prendre plusieurs minutes.",
		"refresh-positions-submit": "Rafraîchir {n} mot clé | Rafraîchir {n} mots clés",
		"success": "L'actualisation des positions a été programmée avec succès.",
		"title": "Rafraîchir les positions"
	},
	"it": {
		"compare": "Le nuove posizioni saranno confrontate con le prime posizioni del giorno.",
		"planning": "Pianificazione dell'aggiornamento",
		"refresh-positions": "Desideri aggiornare il posizionamento di {ids} parola/e chiave? Questa operazione potrebbe richiedere diversi minuti.",
		"refresh-positions-submit": "Aggiorna {n} parola chiave | Aggiorna {n} parole chiave",
		"success": "L'aggiornamento delle posizioni è stato pianificato con successo.",
		"title": "Aggiorna posizioni"
	},
	"pt": {
		"compare": "As novas posições serão comparadas com as primeiras posições do dia.",
		"planning": "A planear a atualização",
		"refresh-positions": "Gostaria de atualizar o posicionamento de {ids} palavra(s)-chave? Esta operação pode demorar vários minutos.",
		"refresh-positions-submit": "Atualizar {n} palavra-chave | Atualizar {n} palavras-chave",
		"success": "A atualização das posições foi agendada com sucesso.",
		"title": "Atualizar posições"
	},
	"pl": {
		"compare": "Nowe pozycje zostaną porównane z pierwszymi pozycjami dnia.",
		"planning": "Planowanie odświeżania",
		"refresh-positions": "Czy chcesz odświeżyć pozycjonowanie {ids} słów kluczowych? Ta operacja może potrwać kilka minut.",
		"refresh-positions-submit": "Odśwież {n} słowo kluczowe | Odśwież {n} słów kluczowych",
		"success": "Aktualizacja pozycji została pomyślnie zaplanowana.",
		"title": "Odśwież pozycje"
	}
}
</i18n>